import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PasskeySummary } from '../../profile-security.models';

@Component({
  selector: 'app-profile-passkeys-factor',
  templateUrl: './passkeys-factor.component.html',
  styleUrl: './passkeys-factor.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasskeysFactorComponent {
  @Input() passkeys: PasskeySummary[] = [];
  @Input() supportsPasskeys = false;
  @Input() registeringPasskey = false;
  @Input() deletingCredentialId: string | null = null;
  @Input() updatingPasskeyCredentialId: string | null = null;
  @Input() showPasskeyNameDialog = false;
  @Input({ required: true }) passkeyNameForm!: FormGroup;
  @Input() showDeletePasskeyDialog = false;
  @Input() deletingPasskeyLabel = '';
  @Input({ required: true }) deletePasskeyForm!: FormGroup;

  @Output() registerPasskey = new EventEmitter<void>();
  @Output() deletePasskey = new EventEmitter<PasskeySummary>();
  @Output() openPasskeyNameDialog = new EventEmitter<PasskeySummary>();
  @Output() closePasskeyNameDialog = new EventEmitter<void>();
  @Output() savePasskeyName = new EventEmitter<void>();
  @Output() closeDeletePasskeyDialog = new EventEmitter<void>();
  @Output() confirmDeletePasskey = new EventEmitter<void>();

  formatDate(value?: string): string {
    if (!value) return '—';
    try {
      return new Intl.DateTimeFormat('es-CL', {
        dateStyle: 'medium',
        timeStyle: 'short',
      }).format(new Date(value));
    } catch {
      return value;
    }
  }
}
